import { render, staticRenderFns } from "./StandardDepartModal.vue?vue&type=template&id=504d932e&scoped=true&"
import script from "./StandardDepartModal.vue?vue&type=script&lang=js&"
export * from "./StandardDepartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d932e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504d932e')) {
      api.createRecord('504d932e', component.options)
    } else {
      api.reload('504d932e', component.options)
    }
    module.hot.accept("./StandardDepartModal.vue?vue&type=template&id=504d932e&scoped=true&", function () {
      api.rerender('504d932e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/StandardDepartModal.vue"
export default component.exports